import React from "react";
import "./Loader.css";

const Loader = ({ size = "normal" }) => {
  const getSpinnerClass = () => {
    if (size === "extra-large") return "spinner-extra-large";
    if (size === "large") return "spinner-large";
    return "";
  };

  return (
    <div className="loader-overlay">
      <div className={`spinner ${getSpinnerClass()}`}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;

